/**
 * Wellness-check protocol (delivery block, Phase 10).
 *
 * A keyholder can ask FinalKey to check on a primary user; the primary is
 * alerted by SMS and email, again after 7 silent days, and after 3 more
 * their LETTERS ONLY are released to the people they chose. Any alive
 * signal — the in-app button, an ALIVE text reply, or simply signing in —
 * cancels it.
 */
import http from './http';

export interface WellnessStatus {
  active: boolean;
  createdAt?: string;
  releaseDueAt?: string;
  secondAlertSent?: boolean;
}

export interface WellnessRequesterStatus {
  active: boolean;
  mine?: boolean;
  releaseDueAt?: string;
}

class WellnessService {
  /** Primary-side: is there a check open on ME? */
  async getMyStatus(): Promise<WellnessStatus> {
    const response = await http.get('/api/wellness-check/status');
    return response.data.data;
  }

  /** Primary-side: "I'm okay" — cancels the open check. */
  async imAlive(): Promise<{ cancelled: boolean }> {
    const response = await http.post('/api/wellness-check/im-alive');
    return response.data.data;
  }

  /** Keyholder-side: is a check already running on this primary? */
  async getStatusFor(primaryUserId: string): Promise<WellnessRequesterStatus> {
    const response = await http.get(`/api/wellness-check/status/${primaryUserId}`);
    return response.data.data;
  }

  /** Keyholder-side: open a wellness check on a primary. */
  async initiate(primaryUserId: string): Promise<{ id: string; releaseDueAt: string }> {
    const response = await http.post('/api/wellness-check/initiate', { primaryUserId });
    if (!response.data.success) {
      throw new Error(response.data.message || 'Could not start the wellness check');
    }
    return response.data.data;
  }
}

export const wellnessService = new WellnessService();
